/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SolvencyV2, SolvencyV2Interface } from "../SolvencyV2";

const _abi = [
  {
    inputs: [],
    name: "DifferentArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedLTVType",
    type: "error",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220a20642a58178a3b597d70d0f20126af643512d97ba245ea8f674f5f8af4e532c64736f6c634300080d0033";

type SolvencyV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SolvencyV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SolvencyV2__factory extends ContractFactory {
  constructor(...args: SolvencyV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SolvencyV2";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SolvencyV2> {
    return super.deploy(overrides || {}) as Promise<SolvencyV2>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SolvencyV2 {
    return super.attach(address) as SolvencyV2;
  }
  connect(signer: Signer): SolvencyV2__factory {
    return super.connect(signer) as SolvencyV2__factory;
  }
  static readonly contractName: "SolvencyV2";
  public readonly contractName: "SolvencyV2";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SolvencyV2Interface {
    return new utils.Interface(_abi) as SolvencyV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SolvencyV2 {
    return new Contract(address, _abi, signerOrProvider) as SolvencyV2;
  }
}
